import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

const CustomTitle = ({  style, required,text, level, color, strong, whiteSpace='normal', fontSize, lineHeight, marginTop, marginBottom, fontWeight, textAlign, className}) => {
  return (
    <Title className={className} level={level} strong={strong} style={{...style, color: color, fontSize: fontSize, whiteSpace: whiteSpace, lineHeight: lineHeight, marginTop: marginTop, marginBottom: marginBottom, fontWeight: fontWeight, textAlign: textAlign }}>
  
      {text}
      {required && <span style={{ color: '#ff4d4f',fontSize:"14px" }}> *</span>}
      
    </Title>
  );
};

export default CustomTitle;